"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConditionTypeSet = void 0;
var observable_array_1 = require("./observable-array");
var allConditionTypeSets = {};
/** Groups condition types into a set in order to be notified conditions for these types change. */
var ConditionTypeSet = /** @class */ (function () {
    /**
    * Creates a set of condition types.
    * @param name The name of the set
    */
    function ConditionTypeSet(name) {
        if (allConditionTypeSets[name])
            throw new Error("A set with the name '" + name + "' has already been created.");
        this.name = name;
        this.types = observable_array_1.ObservableArray.create();
        this.conditions = observable_array_1.ObservableArray.create();
        allConditionTypeSets[name] = this;
    }
    /**
    * Gets all condition type sets that have been created.
    * @returns Array of all condition type sets.
    * */
    ConditionTypeSet.all = function () {
        var all = [];
        for (var type in allConditionTypeSets.keys) {
            all.push(allConditionTypeSets[type]);
        }
        return all;
    };
    /**
    * Gets the condition type set with the specified name.
    * @param name
    */
    ConditionTypeSet.get = function (name) {
        return allConditionTypeSets[name];
    };
    return ConditionTypeSet;
}());
exports.ConditionTypeSet = ConditionTypeSet;
